import { useState, useEffect } from 'react'
import { Sidebar } from '../components/Layout/Sidebar'
import { ReferenceUpload } from '../components/References/ReferenceUpload'
import { ReferenceList } from '../components/References/ReferenceList'
import { GesnUpload } from '../components/References/GesnUpload'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/Common/Tabs'

export const ReferencesPage = () => {
  const [activeTab, setActiveTab] = useState('materials')
  const [refreshKey, setRefreshKey] = useState(0)

  const handleUploadSuccess = () => {
    // Обновляем список справочников
    setRefreshKey(prev => prev + 1)
  }

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />

      <main className="flex-1 overflow-auto">
        <div className="max-w-6xl mx-auto p-6">
          <div className="mb-8">
            <h1 className="text-4xl font-bold mb-2">Справочники</h1>
            <p className="text-gray-600">
              Справочники цен (ФССЦ/ФСЭМ) и нормативная база ГЭСН для расчёта ЛСР
            </p>
          </div>

          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid w-full grid-cols-4 mb-6">
              <TabsTrigger value="materials">Материалы</TabsTrigger>
              <TabsTrigger value="equipment">Оборудование</TabsTrigger>
              <TabsTrigger value="operations">Операции</TabsTrigger>
              <TabsTrigger value="gesn">ГЭСН / ФСНБ</TabsTrigger>
            </TabsList>

            <TabsContent value="materials" className="space-y-6">
              <ReferenceUpload
                referenceType="materials"
                onSuccess={handleUploadSuccess}
              />
              <ReferenceList
                referenceType="materials"
                key={`materials-${refreshKey}`}
              />
            </TabsContent>

            <TabsContent value="equipment" className="space-y-6">
              <ReferenceUpload
                referenceType="equipment"
                onSuccess={handleUploadSuccess}
              />
              <ReferenceList
                referenceType="equipment"
                key={`equipment-${refreshKey}`}
              />
            </TabsContent>

            <TabsContent value="operations" className="space-y-6">
              <ReferenceUpload
                referenceType="operations"
                onSuccess={handleUploadSuccess}
              />
              <ReferenceList
                referenceType="operations"
                key={`operations-${refreshKey}`}
              />
            </TabsContent>

            <TabsContent value="gesn" className="space-y-6">
              <GesnUpload />
            </TabsContent>
          </Tabs>
        </div>
      </main>
    </div>
  )
}
